import React, { useState } from 'react';
import { Box, Button, Collapse, IconButton, Paper, Stack, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import ProductsList from './products_list';
import AddProductsDialog from '../../../../common/warehouse_and_food_partner_order_form/add_products_dialog';
import CopyAllIcon from "@mui/icons-material/CopyAll";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Inventory2Icon from '@mui/icons-material/Inventory2';
import DestinationStockPanel from './destination_stock_panel';

const DestinationCard = ({
                             destination,
                             form,
                             formik,
                             index,
                             withExpirationDate,
                             disabled,
                             disabledPrice,
                             copyProductsToClipboard,
                             pasteProductsFromClipboard,
                             showPasteFromClipboard,
                             onRemoveDestination
                         }) => {
    const [isExpanded, setIsExpanded] = useState(formik?.values?.destinationsList[index]?.isExpanded || false);
    const [showStock, setShowStock] = useState(false);
    const productsCount = formik?.values?.productsList[index]?.length || 0;

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    const toggleStock = () => {
        setShowStock(!showStock);
        setIsExpanded(true);
    };

    if (disabled && productsCount === 0) {
        return <></>
    }

    return (
        <Box sx={ { display: 'flex', alignItems: 'flex-start', gap: 2 } }>
            <Paper variant="outlined" sx={ { flexGrow: 1, p: 3, backgroundColor: disabled ? 'slate.100' : 'slate.50' } }>
                <Box sx={ {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    mb: isExpanded ? 3 : 0
                } }>
                    <Stack direction="row" alignItems="center" spacing={ 1 }>
                        <IconButton onClick={ toggleExpand } size="small" title={ isExpanded ? 'Zwiń' : 'Rozwiń' }>
                            { isExpanded ? <ExpandLessIcon/> : <ExpandMoreIcon/> }
                        </IconButton>
                        <Typography onClick={ toggleExpand } variant="h6"
                                    sx={ { fontWeight: 600, cursor: 'pointer' } }>
                            { destination?.name }
                        </Typography>
                        { !isExpanded && (
                            <Typography variant="body2" color="text.secondary" sx={ { ml: 2 } }>
                                (Liczba pozycji: { productsCount })
                            </Typography>
                        ) }
                    </Stack>

                    <Stack direction="row" spacing={ 2 }>
                        {
                            // the stock helps to complete an order, a read-only order does not need it
                            !disabled &&
                            <Button
                                size="small"
                                startIcon={ <Inventory2Icon/> }
                                onClick={ toggleStock }
                            >
                                { showStock ? 'Ukryj stan magazynowy' : 'Stan magazynowy' }
                            </Button>
                        }
                        {
                            !disabled && isExpanded &&
                            <>
                                {
                                    formik?.values?.productsList[index] && formik?.values?.productsList[index].length > 0 &&
                                    <Button
                                        size="small"
                                        startIcon={ <CopyAllIcon/> }
                                        onClick={ () => copyProductsToClipboard(formik, index) }
                                    >
                                        Kopiuj listę
                                    </Button>
                                }
                                {
                                    showPasteFromClipboard &&
                                    <Button
                                        size="small"
                                        startIcon={ <ContentCopyIcon/> }
                                        onClick={ () => pasteProductsFromClipboard(formik, index) }
                                    >
                                        Wklej listę
                                    </Button>
                                }
                            </>
                        }
                    </Stack>
                </Box>

                <Collapse in={ isExpanded } timeout="auto" unmountOnExit>
                    {/* the stock sits next to the order list, so both can be used at the same time */ }
                    <Box sx={ {
                        display: 'grid',
                        gap: 2,
                        alignItems: 'start',
                        gridTemplateColumns: showStock ? { xs: '1fr', lg: 'minmax(0, 1fr) 440px' } : '1fr'
                    } }>
                        <Box sx={ { minWidth: 0 } }>
                            <ProductsList
                                formik={ formik }
                                productsListIndex={ index }
                                withExpirationDate={ withExpirationDate }
                                disabled={ disabled }
                                disabledPrice={ disabledPrice }
                            />
                            {
                                !disabled &&
                                <Box sx={ { mt: 2 } }>
                                    <AddProductsDialog
                                        foodPartnerId={ form?.foodPartnerId }
                                        formik={ formik }
                                        dateToCalculateExpirationDate={ form?.orderDate }
                                        productsListIndex={ index }
                                    />
                                </Box>
                            }
                        </Box>
                        {
                            !disabled && showStock && (
                                <Box sx={ { position: { lg: 'sticky' }, top: { lg: 16 } } }>
                                    <DestinationStockPanel
                                        destination={ destination }
                                        orderedProducts={ formik?.values?.productsList[index] }
                                        onClose={ () => setShowStock(false) }
                                    />
                                </Box>
                            )
                        }
                    </Box>
                </Collapse>
            </Paper>

            {
                !disabled && destination?.canBeRemoved &&
                <Box sx={ { pt: 2 } }>
                    <IconButton
                        onClick={ () => onRemoveDestination(formik, destination?.position) }
                        title="Usuń lokalizację"
                    >
                        <RemoveCircleIcon/>
                    </IconButton>
                </Box>
            }
        </Box>
    );
};

export default DestinationCard;